import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getIssuers, saveIssuersBatch } from '../../api/issuers';
import type { Issuer } from '../../types/Issuer';
import { t } from '../../i18n/t';

const issuersColumnDefs: ColDef<Issuer>[] = [
  {
    field: 'issuerId',
    headerName: t('issuers.columns.issuerId'),
    width: 120,
    // Natural PK: editable on Add only; existing rows must keep their id.
    editable: (params: EditableCallbackParams<Issuer>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'issuerName',
    headerName: t('issuers.columns.issuerName'),
    flex: 1,
    editable: true,
  },
  {
    field: 'crn',
    headerName: t('issuers.columns.crn'),
    width: 160,
    editable: true,
    cellDataType: 'number',
  },
];

const newIssuerDefaults = (): Partial<Issuer> => ({
  issuerId: 0,
  issuerName: '',
  crn: null,
});

export function IssuersPage() {
  return (
    <LopCrudPage<Issuer>
      resourceCode="issuers"
      titleKey="issuers.pageTitle"
      idField="issuerId"
      getRows={getIssuers}
      saveBatch={(added, modified, deletedIds) =>
        saveIssuersBatch(added, modified, deletedIds as number[])
      }
      columnDefs={issuersColumnDefs}
      newRowDefaults={newIssuerDefaults}
    />
  );
}
